// Optimize Main JavaScript - Funciones de optimización para el tema
(function($) {
  'use strict';
  
  $(document).ready(function() {
    
    // Verificar si estamos específicamente en main-collection
    var isMainCollection = false;
    
    // Verificar si existe la sección main-collection específicamente
    var mainCollectionSection = document.querySelector('[data-ntajax-container][data-ntajax-options*="typeAjax"]');
    if (mainCollectionSection) {
      // Verificar que estamos en una página de colección (no en otras secciones)
      var isCollectionPage = window.location.pathname.includes('/collections/') && 
                           !window.location.pathname.includes('/products/') &&
                           !window.location.pathname.includes('/blogs/') &&
                           !window.location.pathname.includes('/pages/');
      
      if (isCollectionPage) {
        isMainCollection = true;
      }
    }
    
    // Solo ejecutar en páginas de colecciones principales
    if (!isMainCollection) {
      return;
    }
    
    // Función para mover productos agotados al final
    function mostrarAgotadosAlFinal() {
      
      // Buscar todos los productos con badge de agotado
      var agotados = Array.from(document.querySelectorAll('.t4s-product')).filter(function(product) {
        // Verificar si el producto tiene el atributo available: false en el data-product-options
        var productOptions = product.querySelector('[data-product-options]');
        if (productOptions) {
          try {
            var options = JSON.parse(productOptions.getAttribute('data-product-options'));
            if (options.available === false) {
              return true;
            }
          } catch (e) {
            // Error parsing product options - continuar
          }
        }
        
        // También verificar badges de soldout
        var soldoutBadge = product.querySelector('[data-sort*="soldout"]');
        if (soldoutBadge) {
          return true;
        }
        
        return false;
      });
      
      if (agotados.length > 0) {
        // Remover productos agotados de su posición actual
        agotados.forEach(function(product) {
          if (product.parentNode) {
            product.parentNode.removeChild(product);
          }
        });
        
        // Agregar productos agotados al final del grid
        var grid = document.querySelector('.t4s-products');
        if (grid) {
          agotados.forEach(function(product) {
            product.style.display = '';
            grid.appendChild(product);
          });
          

        }
      }
    }
    
    // Ejecutar funciones cuando la página esté lista
    setTimeout(function() {
      mostrarAgotadosAlFinal();
    }, 1000);
    
    // También ejecutar cuando se carguen más productos (AJAX) usando MutationObserver
    var observer = new MutationObserver(function(mutations) {
      var hasNewProducts = false;
      var hasRemovedProducts = false;
      
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList') {
          // Verificar si se agregaron productos nuevos
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1 && (node.classList.contains('t4s-product') || node.querySelector('.t4s-product'))) {
              hasNewProducts = true;
            }
          });
          
          // Verificar si se removieron productos (indicador de recarga)
          mutation.removedNodes.forEach(function(node) {
            if (node.nodeType === 1 && (node.classList.contains('t4s-product') || node.querySelector('.t4s-product'))) {
              hasRemovedProducts = true;
            }
          });
        }
      });
      
      // Solo ejecutar si hay productos nuevos Y no se removieron productos (evita recargas)
      if (hasNewProducts && !hasRemovedProducts) {
        // Usar debounce para evitar múltiples ejecuciones
        clearTimeout(window.agotadosTimeout);
        window.agotadosTimeout = setTimeout(mostrarAgotadosAlFinal, 1000);
      }
    });
    
    // Observar cambios en el contenedor de productos
    var productsContainer = document.querySelector('.t4s-products');
    if (productsContainer) {
      observer.observe(productsContainer, {
        childList: true,
        subtree: true
      });
    }
    
  });
  
})(jQuery); 